module.exports = __webpack_public_path__ + "img/third-logo.912dbb4a.png";